import Wrapper from '@/components/base/Wrapper';
import MenuList from '@/components/menu/Menu';
import ClassSection from '@/components/menu/ClassSection';

const announcement = {
  path: 'announcement',
  component: Wrapper,
  meta: { breadCrumb: 'content.announcement' },
  children: [
    {
      path: '',
      name: 'AnnouncementParentIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/announcement'),
      meta: { rule: 'isParent', layout: 'default' },
      props: { isClass: true, isStudent: true, isParent: true }
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_announcement' },
      children: [
        {
          path: '',
          name: 'AnnouncementParentViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/announcement/StudentView'),
          meta: { rule: 'isParent', layout: 'default' },
          props: { isClass: true, isEditable: true, isStudent: true, isParent: true }
        }
      ]
    }
  ]
};

const announcement_section = {
  path: 'announcement',
  component: Wrapper,
  meta: { breadCrumb: 'content.announcement' },
  children: [
    {
      path: '',
      name: 'AnnouncementParentSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/announcement'),
      meta: { rule: 'isParent', layout: 'default' },
      props: { isClass: true, isStudent: true, isParent: true }
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_announcement' },
      children: [
        {
          path: '',
          name: 'AnnouncementParentSectionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/announcement/StudentView'),
          meta: { rule: 'isParent', layout: 'default' },
          props: { isClass: true, isEditable: true, isStudent: true, isParent: true }
        }
      ]
    }
  ]
};

export default [
  // Parent :: Couse
  // {
  //   path: '/course-parent',
  //   component: Wrapper,
  //   meta: { breadCrumb: 'content.course_list' },
  //   children: [
  //     {
  //       path: '',
  //       name: 'ParentCourseIndex',
  //       component: () => import(/* webpackChunkName: "course-list" */ '@/components/menu/Course'),
  //       meta: { rule: 'isParent', layout: 'default' },
  //       props: { type: 'parent' }
  //     },
  //     {
  //       path: 'success',
  //       name: 'ChangeParent',
  //       component: () => import(/* webpackChunkName: "success" */ '@/pages/Success'),
  //       meta: { rule: 'isParent' },
  //       props: { type: 'change-child' }
  //     },
  //     {
  //       path: 'course/:courseId',
  //       component: Wrapper,
  //       meta: { breadCrumb: 'Biology' },
  //       children: [
  //         {
  //           path: '',
  //           name: 'ParentCourseList',
  //           component: MenuList,
  //           meta: { rule: 'isParent', layout: 'default' },
  //           props: { type: 'parent' }
  //         },
  //         {
  //           path: 'attendance',
  //           name: 'ParentAttendance',
  //           component: () => import(/* webpackChunkName: "attendance" */ '@/pages/attendance'),
  //           meta: { rule: 'isParent', layout: 'default', breadCrumb: 'menu.attendance' }
  //         },
  //         {
  //           path: 'score',
  //           name: 'ParentScore',
  //           component: () => import(/* webpackChunkName: "score" */ '@/pages/score'),
  //           meta: { rule: 'isParent', layout: 'default', breadCrumb: 'menu.score' }
  //         }
  //       ]
  //     }
  //   ]
  // },

  {
    path: '/parent-class',
    component: Wrapper,
    meta: { breadCrumb: 'content.class_list' },
    children: [
      {
        path: '',
        name: 'ParentClassIndex',
        component: () => import(/* webpackChunkName: "teacher-class" */ '@/components/menu/Class'),
        meta: { rule: 'isParent', layout: 'default' },
        props: { type: 'parent' }
      },
      {
        path: 'class/:classId',
        component: Wrapper,
        meta: { breadCrumb: 'content.class_title' },
        children: [
          {
            path: '',
            name: 'ParentCourseIndex',
            component: () => import(/* webpackChunkName: "course-list" */ '@/components/menu/Course'),
            meta: { rule: 'isParent', layout: 'default' },
            props: { type: 'parent' }
          },
          {
            path: 'erapor',
            component: Wrapper,
            meta: { breadCrumb: 'content.erapor' },
            children: [
              {
                path: '',
                name: 'EraporParentView',
                component: () => import(/* webpackChunkName: "teacher-course" */ '@/pages/template_generator/Template'),
                meta: { rule: 'isParent', layout: 'default' },
                props: { type: 'parent', isEditable: false }
              }
            ]
          },
          {
            path: 'success',
            name: 'ChangeParent',
            component: () => import(/* webpackChunkName: "success" */ '@/pages/Success'),
            meta: { rule: 'isParent' },
            props: { type: 'change-child' }
          },
          /* class biasa */
          {
            path: 'course/:courseId',
            component: Wrapper,
            meta: { breadCrumb: 'table.menu' },
            children: [
              {
                path: '',
                name: 'ParentCourseList',
                component: MenuList,
                meta: { rule: 'isParent', layout: 'default' },
                props: { type: 'parent' }
              },
              {
                path: 'attendance',
                name: 'ParentAttendance',
                component: () => import(/* webpackChunkName: "attendance" */ '@/pages/attendance'),
                meta: { rule: 'isParent', layout: 'default', breadCrumb: 'menu.attendance' }
              },
              {
                path: 'score',
                name: 'ParentScore',
                component: () => import(/* webpackChunkName: "score" */ '@/pages/score'),
                meta: { rule: 'isParent', layout: 'default', breadCrumb: 'menu.score' }
              },
              announcement
            ]
          },
          /* section class */
          {
            path: 'course/:courseId/sectionclass',
            component: Wrapper,
            meta: { breadCrumb: 'content.class_section' },
            children: [
              {
                path: '',
                name: 'ParentClassSectionList',
                component: ClassSection,
                meta: { rule: 'isParent', layout: 'default' },
                props: { type: 'parent' }
              },
              {
                path: ':classSectionId',
                component: Wrapper,
                meta: { breadCrumb: 'table.menu' },
                children: [
                  {
                    path: '',
                    name: 'ParentSectionMenuSectionList',
                    component: MenuList,
                    meta: { rule: 'isParent', layout: 'default' },
                    props: { type: 'parent' }
                  },
                  {
                    path: '',
                    name: 'ParentSectionCourseList',
                    component: MenuList,
                    meta: { rule: 'isParent', layout: 'default' },
                    props: { type: 'parent' }
                  },
                  {
                    path: 'attendance',
                    name: 'ParentSectionAttendance',
                    component: () => import(/* webpackChunkName: "attendance" */ '@/pages/attendance'),
                    meta: { rule: 'isParent', layout: 'default', breadCrumb: 'menu.attendance' }
                  },
                  {
                    path: 'score',
                    name: 'ParentSectionScore',
                    component: () => import(/* webpackChunkName: "score" */ '@/pages/score'),
                    meta: { rule: 'isParent', layout: 'default', breadCrumb: 'menu.score' }
                  },
                  announcement_section
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  // Schedule (Student & Parent)
  {
    path: '/child-list',
    name: 'ChildList',
    component: () => import(/* webpackChunkName: "schedule-index" */ '@/components/menu/ParentChild'),
    meta: { rule: 'isParent', layout: 'default', breadCrumb: 'menu.child_list' }
  }
];
